import { trpc } from '@/shared/api/trpc';

export const useUpdateOrganization = () => {
  const utils = trpc.useUtils();
  return trpc.organizations.update.useMutation({
    onSettled: (_data, _err, vars) => {
      if (vars?.id) {
        utils.organizations.findOne.invalidate({ id: vars.id });
      }
      utils.auth.me.invalidate();
    },
  });
};
